// src/workspaces/workspaceAdminApi.ts
import { apiClient } from "@maat/api-base";
var workspaceAdminApi = {
  list: async (params) => {
    return apiClient.get("/main/api/admin/workspaces", { params });
  },
  get: async (workspaceId) => {
    return apiClient.get(`/main/api/admin/workspaces/${workspaceId}`);
  },
  getMembers: async (workspaceId) => {
    return apiClient.get(`/main/api/admin/workspaces/${workspaceId}/members`);
  },
  listProperties: async (workspaceId, params) => {
    return apiClient.get(`/main/api/admin/workspaces/${workspaceId}/properties`, { params });
  },
  getPropertyStats: async (workspaceId) => {
    return apiClient.get(`/main/api/admin/workspaces/${workspaceId}/properties/stats`);
  },
  updateCommission: async (workspaceId, data) => {
    return apiClient.patch(`/main/api/admin/workspaces/${workspaceId}/commission`, data);
  },
  /**
   * Turn listing review on or off for one workspace. Affects listings created from
   * now on — it does not sweep the existing ones, which are live and earning.
   */
  setListingReview: async (workspaceId, data) => {
    return apiClient.patch(`/main/api/admin/workspaces/${workspaceId}/listing-review`, data);
  },
  setSuspension: async (workspaceId, data) => {
    return apiClient.patch(`/main/api/admin/workspaces/${workspaceId}/suspension`, data);
  }
};

export {
  workspaceAdminApi
};
